<template>
  <div id="product">
    <el-row v-if="customer" class="usage" :gutter="10">
      <el-col :span="8">
        <el-card v-if="client.yearly" shadow="never">
          Current yearly bill
          <h3>{{ $root.currency.symbol }}{{ price }}</h3>
        </el-card>

        <el-card v-else shadow="never">
          Current monthly bill
          <h3>{{ $root.currency.symbol }}{{ price }}</h3>
          <el-button
            v-if="client.team"
            type="text"
            size="mini"
            :disabled="true"
          >
            Switch to yearly billing
          </el-button>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="never">
          Next payment due
          <h3>{{ next }}</h3>
          <el-button type="text" size="mini" @click.prevent="billing">View payment history</el-button>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="never">
          Projects Owner
          <h3>{{ rolesOwner.length }}</h3>
          <el-button type="text" size="mini" @click="$router.push('/projects')">List projects</el-button>
        </el-card>
      </el-col>
    </el-row>

    <el-card class="current-product" shadow="always">
      <div slot="header">
        <el-button type="primary" size="mini" @click.prevent="upgrade">Upgrade</el-button>
        <el-button type="default" size="mini" @click.prevent="upgrade">Compare all plans</el-button>
        <h2>Current Plan</h2>
      </div>

      <ProductDescription :client="client" />

      <!--
      <template v-if="!client.enterprise && client.quota">
        <h5>
          <span class="value">1 of {{ client.quota.instances }} cloud servers created</span>
          Cloud servers monthly quota
        </h5>
        <el-progress :percentage="10" status="warning" :show-text="false" />
      </template>
      -->
    </el-card>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import ProductDescription from './ProductDescription'

export default {
  props: {
    user: {
      type: Object,
      default: () => ({})
    },
    client: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    ProductDescription
  },
  data () {
    return {
      customer: null,
      subscription: null
    }
  },
  mounted () {
    this.load()
  },
  computed: {
    price () {
      return !this.client.team || !this.subscription ? 0 : (this.subscription.plan.amount / 100)
    },
    next () {
      return !this.client.team || !this.subscription ? '--' : moment.unix(this.subscription.current_period_end).format('DD MMM YYYY')
    },
    roleOwnerId () {
      return this.rolesOwner.length ? this.rolesOwner[0].id : ''
    },
    rolesOwner () {
      return (this.user.roles || []).filter((r) => r.access === 1)
    }
  },
  methods: {
    load () {
      this.$store.dispatch('getBillingCustomer').then((customer) => {
        this.customer = customer
        this.subscription = customer.subscriptions.data.pop()
      }).catch(() => {})
    },
    upgrade () {
      this.$router.push({ name: 'billing', query: { upgrade: 1, roleId: this.roleOwnerId } })
    },
    billing () {
      this.$router.push({ name: 'billing', query: { roleId: this.roleOwnerId } })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../theme";

  .usage {
    font-size: 14px;

    .el-card {
      background: $--background-color-base;
      height: 130px
    }
  }

  .current-product {
    margin-top: 24px;

    h4 {
      margin-top: 0;

      span {
        display: block;
        color: $--color-text-alt;
        font-size: 14px;
        font-weight: 300;
        line-height: 25px;
      }
    }

    h5 {
      margin-top: 24px;
      margin-bottom: 12px;

      span {
        float: right;
      }
    }

    ul {
      list-style: none;
      padding: 0;
      margin: 0;

      .mdi {
        color: $--color-success;
      }
      li {
        line-height: 24px;
      }
    }
  }
</style>

<style lang="scss">
  @import "../../theme";

  #product {
    .el-card__header {
      background: $--background-color-base;

      h2 {
        margin: 6px 0;
      }
      .el-button {
        float: right;

        &:first-child {
          margin-left: 10px;
        }
      }
    }
  }
</style>
